<template>
  <el-dialog :append-to-body="true" id="reset-password-layer" title="修改签署密码" :visible.sync="dialogVisible" width="530px"
    :close-on-click-modal="false">
    <div class="reset-phone">
      已绑定手机号 <span>{{ showOldPhone }}</span>
    </div>
    <el-form @submit.native.prevent :model="resetForm" :rules="resetRules" ref="resetForm" label-width="0"
      class="reset-Form">
      <el-form-item prop="vcode">
        <el-input size="small" placeholder="请输入手机短信验证码" maxlength="6" v-model="resetForm.vcode"
          oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        <div class="code-btn">
          <el-button type="primary" size="small" plain class="right-btn" :disabled="!sendAuthCode"
            @click="getMsgAuthCode()" v-show="sendAuthCode">获取验证码</el-button>
          <el-button type="primary" size="small" plain v-show="!sendAuthCode" class="right-btn">
            {{ auth_time }}秒</el-button>
        </div>
      </el-form-item>
      <el-form-item prop="pin">
        <el-input size="small" placeholder="请输入6位数字" v-model="resetForm.pin" maxlength="6"
          oninput="value=value.replace(/[^\d]/g,'')"></el-input>
      </el-form-item>
    </el-form>

    <div class="dialog-btns">
      <el-button type="primary" size="small" @click="submitHandle" class="btn-ok">确认</el-button>
      <el-button plain size="small" @click="cancel" class="btn-cancel">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { getSmsVerificationCode } from "@/api/common";
import { changePin } from "@/api/account/account";

export default {
  data() {
    var checkPin = (rule, value, callback) => {
      var pReg = /^\d{6}$/;
      if (!pReg.test(value)) {
        callback(new Error("请输入6位数字"));
      } else {
        callback();
      }
    };

    return {
      sendAuthCode: true,
      auth_time: 60,
      showOldPhone: "",

      dialogVisible: false,
      resetForm: {
        pin: "",
        vcode: "",
      },
      resetRules: {
        pin: [{ required: true, validator: checkPin, trigger: "blur" }],
        vcode: [
          {
            required: true,
            message: "请输入短信验证码",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    //type 1 获取旧手机号验证码
    //type 2 获取新手机号验证码
    getMsgAuthCode(phone) {
      this.sendAuthCode = false;
      getSmsVerificationCode({
        bizType: "changePin",
      })
        .then((res) => {
          if (res.code != "200") {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
            this.sendAuthCode = true;
            this.auth_time = 60;
          } else {
            this.$message({
              message: "短信发送成功",
              type: "success",
            });
            // 倒计时
            this.ole_phone_auth_time = 60;
            var auth_timetimer = setInterval(() => {
              this.auth_time--;
              if (this.auth_time <= 0) {
                this.sendAuthCode = true;
                clearInterval(auth_timetimer);
              }
            }, 1000);
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$message.error('服务器错误！');
        });
    },
    submitHandle() {
      this.$refs["resetForm"].validate((valid) => {
        if (valid) {
          changePin(this.resetForm).then((res) => {
            if (res.code != "200") {
              this.$message({
                showClose: true,
                message: res.message,
                type: "warning",
              });
            } else {
              this.$message({
                showClose: true,
                message: "修改成功！",
                type: "success",
              });

              this.cancel();
              // location.reload()
            }
          });
        } else {
          return false;
        }
      });
    },
    cancel() {
      this.dialogVisible = false;
      this.$refs["resetForm"].resetFields();
      this.resetForm.vcode = "";
      this.resetForm.pin = "";
    },
  },
};
</script>
<style>
/* .reset-Form input,
.reset-Form button {
  height: 48px;
} */
</style>
<style scoped>
.reset-phone {
  /* font-size: 14px;
  color: #333333;
  width: 400px; */
  margin: 0 auto 22px;
}

.code-btn {
  position: absolute;
  right: 0;
  top: 0;
}

/* .reset-Form {
  width: 400px;
  margin: 0 auto;
} */

/* .dialog-btns {
  width: 400px;
  margin: 40px auto 0;
  overflow: hidden;
} */

/* .dialog-btns button {
  display: block;
  width: 140px;
  height: 40px;
  font-size: 14px;
  border-radius: 6px;
  float: left;
} */

.right-btn {
  border-radius: 0 4px 4px 0;
}
</style>
